import { render, staticRenderFns } from "./ValueFormatedMoney.vue?vue&type=template&id=ecc78bac"
import script from "./ValueFormatedMoney.vue?vue&type=script&lang=js"
export * from "./ValueFormatedMoney.vue?vue&type=script&lang=js"
import style0 from "./ValueFormatedMoney.vue?vue&type=style&index=0&id=ecc78bac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports